"use client";

import HeaderImage from "@/components/ui/header-image";
import { Button } from "@/components/ui/button";
import DescriptionBlock from "@/components/entities/description-block";
import { useCollectionData } from "../../hooks/useCollectionData";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

const DetailCollectionHeader = () => {
  const t = useTranslations();
  const { detailCollection } = useCollectionData();
  if (!detailCollection || detailCollection.loading || !detailCollection.detailCollection) return null;

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("collections"), url: "/collections" },
  ];

  const scrollToSection = () => {
    const section = document.getElementById("collectionProducts");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <HeaderImage image={detailCollection.detailCollection.image}>
        <div className={S.headerImageContent}>
          <h1 className={S.collectionTitle}>{detailCollection.detailCollection.title}</h1>
          <Button onClick={scrollToSection} variant="white">
            {t("seeProducts")}
          </Button>
        </div>
      </HeaderImage>
      <DescriptionBlock
        breadcrumbs={breadcrumbs}
        title={detailCollection.detailCollection.subtitle}
        description={detailCollection.detailCollection.description ?? ""}
      />
    </>
  );
};

export default DetailCollectionHeader;
